// Configuration file that loads and provides environment variables with proper type handling and fallbacks

// API Configuration
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:18888/';

// Storage Configuration
export const MAX_STORAGE_SIZE = 
  parseInt(process.env.REACT_APP_MAX_STORAGE_SIZE || '5242880', 10); // Default 5MB

export const CHAT_STORAGE_KEY = 
  process.env.REACT_APP_CHAT_STORAGE_KEY || 'zkml-chat-messages';

export const SESSIONS_KEY = 
  process.env.REACT_APP_SESSIONS_KEY || 'zkml-sessions';

// Default Settings
export const DEFAULT_OPENROUTER_API_KEY = ''; // OpenRouter API key is always user-provided

export const DEFAULT_MAX_CYCLES = 
  parseInt(process.env.REACT_APP_DEFAULT_MAX_CYCLES || '2', 10);

// Fixed localStorage keys for user-provided values
export const OPENROUTER_API_KEY_STORAGE = 'openrouter_api_key';
export const MAX_CYCLES_STORAGE = 'max_cycles';
